module.exports = __webpack_public_path__ + "img/no_viewed.19964794.svg";